import ChangePIN from './v1';

export {
  ChangePIN,
};

export default ChangePIN;
